/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import styled from 'styled-components/native';

import Icons from './../../assets/icons';
import { getScaledValue } from '../../ui/styled';

import { Button } from 'renative';
// import {
//     getScaledValue
// } from 'renative';

export const Container = styled.View.attrs({})`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  background-color: #000000;

  justify-content: center;
  align-items: center;

  padding-bottom: ${getScaledValue(100)}px;
`;

export const ContentLogo = styled.View.attrs({})`
  flex-direction: row;
  align-items: center;
  marginbottom: ${getScaledValue(30)}px;
`;

export const LogoIcon = styled(Icons).attrs({
  icon: 'logo',
  width: getScaledValue(103),
  height: getScaledValue(100),
})`
  margin-right: -${getScaledValue(12)}px;
`;

export const LogoText = styled.Text.attrs({})`
  font-size: ${getScaledValue(30)}px;
  font-weight: 300;
  color: #ffffff;
  margin-top: -${getScaledValue(12)}px;
`;

export const ContentWelcome = styled.View.attrs({})`
  max-width: ${getScaledValue(300)}px;
  margin-bottom: 20px;
`;

export const WelcomeTitle = styled.Text.attrs({})`
  font-size: ${getScaledValue(24)}px;
  text-align: center;
  color: #ffffff;
  font-family: PTSans-Bold;
  margin-bottom: ${getScaledValue(12)}px;
`;

export const WelcomeText = styled.Text.attrs({})`
  font-size: ${getScaledValue(12)}px;
  color: #ffffff;
  margin-bottom: ${getScaledValue(4)}px;
  text-align: center;
  font-family: PTSans-Regular;
  ${(props: { bold?: string; active?: boolean; theme: { primary: string } }) =>
    props.bold
      ? `
            font-family: PTSans-Bold;
        `
      : `
        `}
`;

export const ContentAccess = styled.Text.attrs({})`
  max-height: ${getScaledValue(60)}px;
`;

import PinInputEntry from '../../components/Pin';

export const PinInput = styled(PinInputEntry).attrs({
  placeholder: ' ',
  digits: 5,
})`
  background-color: rgba(255, 255, 255, 0.2);
  borderradius: ${getScaledValue(3)}px;
  margin: ${getScaledValue(5)}px;
  width: ${getScaledValue(44)}px;
  height: ${getScaledValue(56)}px;
  border-width: 0.5px;
  font-family: Inter-Light;
  font-size: ${getScaledValue(16)}px;
  text-align: center;
  border-color: rgba(255, 255, 255, 0.3);
  color: #ffffff;
`;

export const AccessButton = styled(Button).attrs({
  textStyle: {
    fontFamily: 'Inter-Light',
    color: '#ffffff',
    fontSize: getScaledValue(16),
  },
})`
  marginhorizontal: ${getScaledValue(20)}px;
  borderradius: ${getScaledValue(6)}px;
  height: ${getScaledValue(40)}px;
  min-width: ${getScaledValue(150)}px;
  margintop: ${getScaledValue(20)}px;
  ${(props: { bold?: string; active?: boolean; theme: { primary: string } }) =>
    props.active
      ? `
            background: ${(props: { bold?: string; active?: boolean; theme: { primary: string } }) => props.theme.primary};
        `
      : `
            backgroundColor: #999999;
        `}
`;

export const LogoImage = styled.ImageBackground.attrs({
  source: require('./../../assets/logo.png'),
  imageStyle: {
    resizeMode: 'contain',
  },
})`     
    margin: 0 auto ${getScaledValue(10)}px;
    width: ${getScaledValue(160)}px
    height: ${getScaledValue(60)}px;
`;
